import { ComponentClass } from 'react';

import { ResourceLayer } from './ResourceLayer';
import { Repeater } from './Repeater';
import { components as antdComponents } from '../modules/antd';
import { components as calendarComponents } from '../modules/calendar';
import { components as webanaComponents } from '../modules/webana';
import { components as sezakoComponents } from '../modules/sezako';

export type ComponentLoader = () => Promise<any>;

export class ComponentStore {
  private static sharedInstance: ComponentStore;

  loadedComponents: { [key: string]: ComponentClass } = {};

  private components: { [key: string]: ComponentLoader } = {};

  static shared(): ComponentStore {
    if (!ComponentStore.sharedInstance) {
      ComponentStore.sharedInstance = new ComponentStore();
    }
    return ComponentStore.sharedInstance;
  }

  constructor() {
    const components = Object.assign(
      {},
      antdComponents,
      calendarComponents,
      webanaComponents,
      sezakoComponents
    );
    for (let key of Object.keys(components)) {
      this.registerComponentLoader(key, components[key]);
    }
    this.registerComponentLoader('Resource', async () => ResourceLayer);
    this.registerComponentLoader('Repeater', async () => Repeater);
  }

  registerComponentLoader(key: string, component: ComponentLoader) {
    this.components[key] = component;
  }

  loadComponent = async (key: string) => {
    const comp = await this.components[key]();
    this.loadedComponents[key] = comp;
  };

  getComponent(key: string): ComponentClass | null {
    const component = this.components[key];

    if (!component) {
      // console.log(this.components);
      throw new Error(`No component found for key ${key}`);
    }

    return this.loadedComponents[key] || null;
  }
}



// WEBPACK FOOTER //
// ./src/components/ComponentStore.ts